module.exports = __webpack_public_path__ + "img/icon_default_portrait@2x.7e1b6144.png";